const Predefined = 0;
const PickAndMix = 1;
let chosenItems = [];

if (document.readyState !== "loading") {
  runOnStart();
} else {
  console.log(document.readyState);
  document.addEventListener("DOMContentLoaded", function () {
    runOnStart();
  });
}

// do something once the dom is loaded

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

/* FUNCTIONS */
function runOnStart() {
  /*
  const product_id = $("#sub-container").data('product-id');
  const config = {
    productId: product_id, // Required
    injectionParent: '#sub-container', // The node that will have the widget injected in
    injectionMethod: 'append', // How will the widget be injected 
    injectFn: (node, target) => {}, // Runs a custom injection function 
    // selectors: {
    //   price: ['.my-price-selector'], // the selectors that will be updated based on subscription
   //    variant: ['.variant-selector'] // The variants to watch for to update the subscription prices
    // }
  }; */

  //testing out copilot
  console.log(document.readyState);

  waitForElm(".rc_widget").then((elm) => {
    console.log("Element is ready");
    console.log(elm);
    if (document.getElementsByTagName("product-form").length) {
      console.log("removed duplicated widget");
      // document.getElementsByTagName("product-form")[0].remove();
      window.ReChargeWidget.destroyAllWidgets();
    }
  });

  //  window.ReChargeWidget.createWidget(config);

  // if (document.getElementsByClassName("rc_widget").length) {
  //   console.log("there is a widget");
  //   window.ReChargeWidget.destroyAllWidgets();
  //   window.ReChargeWidget.createWidget(config);

  // } else {
  //   //log "there are no widgets on page"
  //   console.log("there are no widgets on page");
  //   window.ReChargeWidget.createWidget(config);
  // }

  //log the document ready state
  // console.log(document.readyState);
  //check if the document is ready and log the document's ready state if it is not
  //window.ReChargeWidget.createWidget(config);
  const bundlebar = new Bundlebar({
    blur: false,
    overlay: true,
  });

  // Inject bundle line items into the product form
  setLineItems(document.getElementById("bundle-line-items"));

  // Copy bundle drawer HTML to mobile drawer
  resetMobileBundleOverview();

  // Set bundle item drawer to height of currently visible bundle-groups element
  // adjustBundleItemDrawerSize();

  // Allow close item details modal when clicking outside the modal
  document
    .getElementById("bundle-modal-container")
    .addEventListener("click", (event) => {
      location.href = "#bundle-info";
    });

  // Update the bundle add-to-cart button
  initializeBundleAddToCart();

  /* Detect variant changes */
  /* Note: Variant radio being name="Title" may be specific to Dawn theme */
  var variantSelector = document.getElementsByName("Title");
  variantSelector.forEach((variantRadio) => {
    variantRadio.addEventListener("change", updateSelectedBundle);
  });

  /* Update modal when clicking "view details" */
  const viewDetailsButton = Array.from(
    document.getElementsByClassName("bundle-item-details")
  );
  viewDetailsButton.forEach((button) => {
    button.addEventListener("click", (event) => {
      const groupItemCard = event.target.closest(".bundle-group-item-card");
      document.querySelector(".bundles-quickview-img").src =
        groupItemCard.dataset.src;
      document.querySelector(".bundles-quickview-title").innerHTML =
        groupItemCard.dataset.name;
      document.querySelector(".bundles-quickview-price").innerHTML =
        groupItemCard.dataset.price;
      document.querySelector(".bundles-quickview-description").innerHTML =
        groupItemCard.dataset.description;
    });
  });

  /* Listen for add/remove bundle items */
  var addBundleItem = Array.from(
    document.getElementsByClassName("add-bundle-item")
  );
  addBundleItem.forEach((button) => {
    button.addEventListener("click", (event) => {
      handleClickAddButton(event.target);
    });
  });

  var bundleItemMinus = Array.from(
    document.getElementsByClassName("bundle-item-qty-minus")
  );
  bundleItemMinus.forEach((button) => {
    button.addEventListener("click", (event) => {
      updateItemQty("remove", event.target);
    });
  });

  var bundleItemPlus = Array.from(
    document.getElementsByClassName("bundle-item-qty-plus")
  );
  bundleItemPlus.forEach((button) => {
    button.addEventListener("click", (event) => {
      updateItemQty("add", event.target);
    });
  });

  var bundleItemQtyInput = Array.from(
    document.getElementsByClassName("bundle-item-qty quantity")
  );
  bundleItemQtyInput.forEach((el) => {
    inputElmt = el.querySelector("input");
    inputElmt.addEventListener("keyup", (event) => {
      updateItemQty("change", event.target);
    });
  });

  // Initially disable add-to-cart for Pick & Mix
  const bundleSectionElements = Array.from(
    document.getElementsByClassName("bundle-section")
  );
  bundleSectionElements.forEach((bundleSection, index) => {
    if (
      !isHidden(bundleSection) &&
      bundleSection.dataset.bundleType == PickAndMix
    ) {
      const bundleAddToCartButtons = Array.from(
        document.getElementsByClassName("bundle-button--primary")
      );
      bundleAddToCartButtons.forEach((button) => {
        button.disabled = "disabled";
      });
      setTimeout(() => {
        document.querySelector("[type=submit]").disabled = "disabled";
      }, 500);
    }
  });

  // Disable add-to-cart for Predefined that includes any unavailable items
  bundleSectionElements.forEach((bundleSection, index) => {
    if (
      !isHidden(bundleSection) &&
      bundleSection.dataset.bundleType == Predefined &&
      bundleSection.querySelector(".bundle-item-unavailable")
    ) {
      const bundleAddToCartButtons = Array.from(
        document.getElementsByClassName("bundle-button--primary")
      );
      bundleAddToCartButtons.forEach((button) => {
        button.disabled = "disabled";
      });
      setTimeout(() => {
        document.querySelector("[type=submit]").disabled = "disabled";
      }, 500);
    }
  });
}

var cartClickHandler = async function (event) {
  // Prevent the link from updating the URL
  event.preventDefault();
  let selling_plan = "";
  var selling_plans = $("[name*='selling_plan']:checked");
  if ($(selling_plans).length) {
    if ($(selling_plans).first().val() == "onetime") {
      selling_plan = "onetime";
    } else {
      selling_plan = $(".rc_widget__option__plans__dropdown")
        .find(":selected")
        .val();
    }
  }
  let properties = {
    Contains: document.querySelector('[name="properties[Contains]"]').value,
  };
  chosenItems.forEach((item) => {
    const propertiesValue = `{location_id:${item.locationId}, inventory_id:${item.inventoryId}}`;
    properties[`_bundle_item_${item.index}`] = propertiesValue;
  });
  // console.log("properties:", properties);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  //console.log("Params", queryString);
  let sPlanId = urlParams.get("spid");
  let collectionId = urlParams.get("collection_id");
  //console.log("Variant ID", this.dataset.variantId);
  //console.log("Product ID", this.dataset.productId);
  //console.log("Collection ID", collectionId);
  //console.log("Chosen Items", chosenItems);
  //console.log("Properties", properties);
  const containsString = properties["Contains"];
  const newContainsString = containsString.replace(/,\s*/g, "\n");
  //console.log("Formatted Contains:\n", newContainsString);
  //console.log("SPID ", sPlanId);
  const variant_dataset_id = this.dataset.variantId;
  if (sPlanId == null) {
    if (this.dataset.productId == "8659187171466") {
      sPlanId = 1923285130;
      collectionId = 302831894666;
    } else if (this.dataset.productId == "8659187504226") {
      sPlanId = 1964343434;
      collectionId = 331749687434;
    }
  }
  if (sPlanId == null) {
    //getDefaultSubscriptionId(variant_dataset_id, properties);
  } else {
    //console.log("with value: " + this.dataset.variantId);
    //console.log("id " + this.dataset.variantId);
    //console.log(properties);
    //console.log(sPlanId);
    const bundleProductData = {
      variantId: this.dataset.variantId,
      productId: this.dataset.productId,
      sellingPlan: sPlanId,
    };
    const groupedSelections = Object.values(
      chosenItems.reduce((acc, item) => {
        const key = `${item.productId}-${item.variantId}`;

        if (!acc[key]) {
          acc[key] = {
            collectionId: collectionId,
            externalProductId: item.productId,
            externalVariantId: item.variantId,
            quantity: 0,
          };
        }

        acc[key].quantity += 1;

        return acc;
      }, {})
    );
    /*
    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: chosenItems.map((item) => ({
        collectionId: collectionId,
        externalProductId: item.productId,
        externalVariantId: item.variantId,
        quantity: 1,
      })),
    };
    */
   const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: groupedSelections,
    };
    //console.log("Bundle Data:", JSON.stringify(bundle));
    const rbId = await recharge.bundle.getBundleId(bundle);
    const cartData = {
      items: [
        {
          id: bundleProductData.variantId,
          quantity: 1,
          selling_plan: bundleProductData.sellingPlan,
          properties: { Contents: newContainsString, _rb_id: rbId },
        },
      ],
    };
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    });
    console.log("Added to cart");
    var has_cookie_offer = getCookie('sub_dis');
    if(has_cookie_offer != null){
      window.SLIDECART_APPLY_DISCOUNT(has_cookie_offer);
    }
    console.log("Cookie: ", has_cookie_offer);
    window.SLIDECART_UPDATE();
  }
  showStep4();
};
//get the value of data-parent-product-id from the product form
function addWildStep4(el) {
  console.log(el);
  const variant_id = el.dataset.variantId;
  let properties = {
    Contains: "Recurring Seafood Box",
  };
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var sPlanId = urlParams.get("spid");
  console.log(sPlanId);

  if (sPlanId == null) {
    getDefaultSubscriptionId(variant_id, properties);
    console.log("value == null");
  } else {
    axios
      .post("/cart/add.js", {
        items: [
          {
            quantity: 1,
            id: variant_id,
            properties,
            selling_plan: sPlanId,
          },
        ],
      })
      .then(function (res) {
        window.SLIDECART_UPDATE();
        // window.SLIDECART_OPEN();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  showStep4();
}
function getDefaultSubscriptionId(variant_data_id, properties) {
  var parent_product_form = document.querySelector("[data-parent-product-id]");
  //const productForm = document.querySelector("[data-product-id]");
  console.log(parent_product_form);
  const parentProductId = parent_product_form.dataset.parentProductId;
  const default_selling_plan = window.ReChargeWidget.api
    .fetchProduct(parentProductId)
    .then((product) => {
      console.log(product);
      var selling_plans = product.selling_plan_groups[0].selling_plans;
      //filter() selling plans to include only those with a order_interval_frequency of 30 and a order_interval_unit type of day or a order_interval_unit type of month and order_interval_frequency of 1

      var filtered_selling_plans = selling_plans.filter(
        function (selling_plan) {
          return (
            (selling_plan.order_interval_frequency == 30 &&
              selling_plan.order_interval_unit_type == "day") ||
            (selling_plan.order_interval_frequency == 1 &&
              selling_plan.order_interval_unit_type == "month")
          );
        }
      );
      var sell_plan_id = filtered_selling_plans[0].selling_plan_id;
      console.log(sell_plan_id);
      console.log(variant_data_id);
      console.log(properties);

      axios
        .post("/cart/add.js", {
          items: [
            {
              quantity: 1,
              id: variant_data_id,
              properties,
              selling_plan: sell_plan_id,
            },
          ],
        })
        .then(function (res) {
          window.SLIDECART_UPDATE();
          // window.SLIDECART_OPEN();
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(filtered_selling_plans[0].id);
    });

  return default_selling_plan;
}

function countCartItems() {
  const cartButtonLabel = document
    .querySelector(".cart_button")
    .querySelector(".button_label");
  let currentCartCount = 0;
  const cartCount = document.querySelector(".cart_count");
  if (cartCount) {
    currentCartCount = parseInt(
      cartCount.querySelector("[data-cart-count]").innerHTML
    );
    cartCount.querySelector("[data-cart-count]").innerHTML = `${
      currentCartCount + 1
    }`;
  }
  //update label text if cartCount span does not exist
  else {
    cartButtonLabel.innerHTML =
      cartButtonLabel.innerHTML + ` (${currentCartCount + 1})`;
  }
}

function initializeBundleAddToCart() {
  const bundleAddToCart = document.getElementById("bundle-add-to-cart");
  const variantId = bundleAddToCart.dataset.variantId;
  bundleAddToCart.removeEventListener("click", cartClickHandler, false);
  bundleAddToCart.addEventListener("click", cartClickHandler, false);
  const bundleAddToCartMobile = document.getElementById(
    "bundle-add-to-cart-mobile"
  );
  bundleAddToCartMobile.removeEventListener("click", cartClickHandler, false);
  bundleAddToCartMobile.addEventListener("click", cartClickHandler, false);
  bundleAddToCartMobile.addEventListener("click", (event) => {
    document.getElementById("bundle-item-drawer-mobile").className = document
      .getElementById("bundle-item-drawer-mobile")
      .className.replace(" open", "");
  });
}

function adjustBundleItemDrawerSize() {
  const bundleGroupsElements = Array.from(
    document.getElementsByClassName("bundle-groups")
  );
  bundleGroupsElements.forEach((groupsElement, index) => {
    if (!isHidden(groupsElement.closest(".bundle-section"))) {
      const height = (groupsElement.getBoundingClientRect().height / 3) * 2;
      document.getElementById("bundle-item-drawer-desktop").style.maxHeight =
        height + "px";
    }
  });
}

function isHidden(el) {
  var style = window.getComputedStyle(el);
  return style.display === "none" || style.visibility === "hidden";
}

function resetMobileBundleOverview() {
  const bundleOverview = document.getElementById("bundle-overview");
  document.getElementById("bundle-overview-mobile").innerHTML =
    bundleOverview.innerHTML.replace(
      "bundle-add-to-cart",
      "bundle-add-to-cart-mobile"
    );
  initializeBundleAddToCart();
}

/* Pick & Mix add/remove item functions */
function handleClickAddButton(btn) {
  const bundleGroupSection = btn.closest(".bundle-group-section");
  const groupChosenQty = parseInt(bundleGroupSection.dataset.chosenQty);
  const groupMaxQty = parseInt(bundleGroupSection.dataset.maxQty);

  if (groupChosenQty < groupMaxQty) {
    const itemCard = btn.parentNode;
    const quantityElmt = itemCard.querySelector(".bundle-item-qty");
    toggleButtonAndQty(btn, quantityElmt);
    updateItemQty("add", btn);
  }
}

function updateItemQty(action, btn) {
  document.getElementById("bundle-overview-mobile").innerHTML = "";
  const bundleGroupSection = btn.closest(".bundle-group-section");
  const itemCard = btn.closest(".bundle-group-item-card");
  const bundleSection = itemCard.closest(".bundle-section");
  const itemImageSrc = itemCard.dataset.src;
  const quantityElmt = btn.closest("quantity-input");
  const addItemBtn = itemCard.querySelector(".add-bundle-item");
  const quantityInput = itemCard.querySelector("input");
  let currentQty = parseInt(quantityInput.value);
  const maxQty = parseInt(quantityInput.max);
  const groupChosenQty = parseInt(bundleGroupSection.dataset.chosenQty);
  const groupMaxQty = parseInt(bundleGroupSection.dataset.maxQty);
  const groupMaxQtyMessage = itemCard
    .closest(".bundle-group-section")
    .querySelector(".bundle-group-max-qty-message");
  const chosenItemCount = chosenItems.length;
  const lineItems = bundleSection.querySelector(".line-items");
  const listItemElmt = itemCard.parentNode;
  const itemTitle = listItemElmt.dataset.title;
  const itemLocationId = listItemElmt.dataset.locationId;
  const itemInventoryId = listItemElmt.dataset.inventoryId;
  const selectedBundleType =
    bundleSection.dataset.bundleType == Predefined
      ? "“Predefined”"
      : "Create Your Own";
  const selectedBundleTotalQty = bundleSection.dataset.bundleTotalQty;

  if (!chosenItems[itemTitle]) chosenItems[itemTitle] = 0;
  lineItems.innerHTML = "";
  let contains = "";
  let lineItemHTML = "";

  // REMOVE
  if (action === "remove") {
    currentQty = currentQty - 1;
    quantityInput.value = currentQty;

    if (currentQty == 0) {
      toggleButtonAndQty(addItemBtn, quantityElmt);
    }

    let lineItemIndex = 0;
    chosenItems.forEach((item) => {
      if (item.title === itemTitle) lineItemIndex = item.index;
    });
    chosenItems = chosenItems.filter((item) => item.index !== lineItemIndex);
    chosenItems.forEach((item, index) => {
      item.index = index;
    });
    const newGroupChosenQty = groupChosenQty - 1;
    bundleGroupSection.dataset.chosenQty = newGroupChosenQty;
    groupMaxQtyMessage.style.display = "none";

    const drawerItemElmts = Array.from(
      document.getElementsByClassName(
        `bundle-group-${bundleGroupSection.dataset.groupId}-drawer-li`
      )
    );
    for (var i = drawerItemElmts.length - 1; i >= 0; i--) {
      const currentElement = drawerItemElmts[i];
      if (currentElement.querySelector("span").innerHTML == itemTitle) {
        currentElement.querySelector("img").src =
          "https://cdn.shopify.com/s/files/1/0586/9531/9743/files/image-placeholder-square-small.jpg?v=1627658323";
        currentElement.querySelector("span").innerHTML = "No item selected";
        break;
      }
    }

    //enable all plus buttons in this group if the new newGroupChosenQty < groupMaxQty
    if (newGroupChosenQty < groupMaxQty) {
      const qtyPlusButtons = Array.from(
        bundleGroupSection.getElementsByClassName("bundle-item-qty-plus")
      );
      qtyPlusButtons.forEach((button) => {
        button.disabled = "";
      });
    }
  }

  // ADD
  else if (action === "add") {
    if (currentQty == "") currentQty = 0;
    currentQty = currentQty + 1;
    if (currentQty == 1) quantityInput.value = 1;
    quantityInput.value = currentQty;
    if (groupChosenQty < groupMaxQty) {
      const itemCard = btn.closest(".bundle-group-item-card");
      chosenItems.push({
        index: chosenItemCount,
        title: itemTitle,
        locationId: itemLocationId,
        inventoryId: itemInventoryId,
        variantId: itemCard.dataset.variantId,
        productId: itemCard.dataset.productId,
      });

      const newGroupChosenQty = groupChosenQty + 1;
      bundleGroupSection.dataset.chosenQty = newGroupChosenQty;
      if (newGroupChosenQty == groupMaxQty) {
        groupMaxQtyMessage.style.display = "";
      }

      const drawerItemElmts = Array.from(
        document.getElementsByClassName(
          `bundle-group-${bundleGroupSection.dataset.groupId}-drawer-li`
        )
      );
      for (var i = 0; i < drawerItemElmts.length; i++) {
        const currentElement = drawerItemElmts[i];
        if (
          currentElement.querySelector("span").innerHTML == "No item selected"
        ) {
          currentElement.querySelector("img").src = itemImageSrc;
          currentElement.querySelector("span").innerHTML = itemTitle;
          break;
        }
      }

      //disable all plus buttons in this group if the new newGroupChosenQty == groupMaxQty
      if (newGroupChosenQty == groupMaxQty) {
        const qtyPlusButtons = Array.from(
          bundleGroupSection.getElementsByClassName("bundle-item-qty-plus")
        );
        qtyPlusButtons.forEach((button) => {
          button.disabled = "disabled";
        });
      }
    }
  }
  // CHANGE
  else if (action === "change") {
    if (currentQty > maxQty) quantityInput.value = maxQty;
  }
  // NON-VALID ACTION
  else {
    console.error(action.toUpperCase(), "is an invalid argument");
  }

  const bundleItemCountSpans = Array.from(
    document.getElementsByClassName("bundle-item-count")
  );
  bundleItemCountSpans.forEach((span) => {
    span.innerHTML = chosenItems.length;
  });
  resetMobileBundleOverview();
  if (currentQty === maxQty) initializeBundleAddToCart();

  let containsDict = {};
  chosenItems.forEach((item) => {
    if (!containsDict[item.title]) containsDict[item.title] = 1;
    else containsDict[item.title]++;
  });
  for (const [title, qty] of Object.entries(containsDict)) {
    contains += `${qty}x ${title}, `;
  }
  contains = contains.substring(0, contains.length - 2);
  const containsHTML = `<input class="contains" type="hidden" name="properties[Contains]" value="${contains}">`;
  chosenItems.forEach((item, index) => {
    lineItemHTML += `<input class="bundle-item-contains" type="hidden" data-name="${item.title}" name="properties[_bundle_item_${index}]" value="{location_id:${item.locationId}, inventory_id:${item.inventoryId}}">`;
  });

  lineItems.innerHTML = containsHTML + lineItemHTML;
  setLineItems(lineItems);

  //enable or disable add-to-cart
  if (
    selectedBundleType == "Create Your Own" &&
    selectedBundleTotalQty > chosenItems.length
  ) {
    document.getElementById("bundle-add-to-cart").disabled = "disabled";
    document.getElementById("bundle-add-to-cart-mobile-outer").disabled =
      "disabled";
    document.querySelector("[type=submit]").disabled = "disabled";
    resetMobileBundleOverview();
  } else {
    document.getElementById("bundle-add-to-cart").disabled = "";
    document.querySelector("[type=submit]").disabled = "";
    // document.querySelector('.mobile-bundlebar-btn').disabled = "";
    document.getElementById("bundle-add-to-cart-mobile-outer").disabled = "";
    resetMobileBundleOverview();
  }
}

function toggleButtonAndQty(button, quantityElmt) {
  if (button.style.display == "none") {
    button.style.display = "";
    quantityElmt.style.display = "none";
  } else {
    button.style.display = "none";
    quantityElmt.style.display = "flex";
  }
}

function updateSelectedBundle() {
  // Show/hide the linked bundle
  var bundleSections = Array.from(
    document.getElementsByClassName("bundle-section")
  );
  bundleSections.forEach((bundleSection) => {
    bundleSection.style.display = "none";
  });

  var selectedBundle = document.querySelector(
    `[data-bundle-variant-id="${this.value}"]`
  );
  selectedBundle.style.display = "";
  const selectedBundleType =
    selectedBundle.dataset.bundleType == Predefined
      ? "Predefined"
      : "Create Your Own";
  console.log("selected variant:", this.value, ":", selectedBundleType);
  const selectedBundleTotalQty = selectedBundle.dataset.bundleTotalQty;
  if (
    (selectedBundleType == "Create Your Own" &&
      selectedBundleTotalQty > chosenItems.length) ||
    (selectedBundleType == "Predefined" &&
      selectedBundle.querySelector(".bundle-item-unavailable"))
  ) {
    const bundleAddToCartButtons = Array.from(
      document.getElementsByClassName("bundle-button--primary")
    );
    bundleAddToCartButtons.forEach((button) => {
      button.disabled = "disabled";
    });
    setTimeout(() => {
      document.querySelector("[type=submit]").disabled = "disabled";
    }, 500);
  } else {
    const bundleAddToCartButtons = Array.from(
      document.getElementsByClassName("bundle-button--primary")
    );
    bundleAddToCartButtons.forEach((button) => {
      button.disabled = "";
    });
    setTimeout(() => {
      document.querySelector("[type=submit]").disabled = "";
    }, 500);
  }

  // adjustBundleItemDrawerSize();

  // Update the line items
  setLineItems(selectedBundle.firstElementChild);
}

function setLineItems(bundleLineItems) {
  // Remove existing line items if present
  try {
    document.getElementById("cart-line-items").remove();
  } catch (error) {}

  var productForm = document
    .getElementsByTagName("product-form")[0]
    .getElementsByTagName("form")[0];

  //select sub-container div
  // var productForm = document.getElementById("sub-container");
  // var lineItems = document.createElement("input");
  // lineItems.name = "properties";
  // var lineItemNodes = Array.from(bundleLineItems.children);
  // var propertiesString = "{";
  // lineItemNodes.forEach((node, index) => {
  //   const isLast = index === lineItemNodes.length - 1;
  //   const startIndex = node.name.indexOf("[") + 1;
  //   const endIndex = node.name.indexOf("]");
  //   const propertyKey = node.name.substring(startIndex, endIndex);
  //   const propertyValue = node.value;
  //   propertiesString += `'${propertyKey}': '${propertyValue}'`;
  //   if (!isLast) propertiesString += ",";
  // });
  // propertiesString += "}";
  // lineItems.value = propertiesString;
  // lineItems.type = "hidden";
  const cartLineItems = document.createElement("div");
  cartLineItems.id = "cart-line-items";
  cartLineItems.innerHTML = bundleLineItems.innerHTML;
  var productFormFirstChild = productForm.firstChild;
  productForm.insertBefore(cartLineItems, productFormFirstChild);
}
